import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  updateTitle,
  updateSlug,
  updateShortDescription,
  updateContent,
  updateThumbnailImage,
  updateFeaturedImage,
  updateAdditionalImages,
} from "../redux/news/actions";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

const authHeaders = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
});

function PreviewNews() {
  const dispatch = useDispatch();
  const { title, slug, shortDescription, content, thumbnailImage, featuredImage, additionalImages } = useSelector(
    (state) => state.news
  );

  const [publishError, setPublishError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${BASE_URL}/api/news/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
        body: JSON.stringify({
          title,
          slug,
          shortDescription,
          content,
          thumbnailImage,
          featuredImage,
          additionalImages,
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setPublishError(data.message);
        return;
      }
      setPublishError(null);
      setSuccessMsg(true);
    } catch (error) {
      setPublishError(error.message);
    }
  };

  const handleEmptyField = () => {
    dispatch(updateTitle(""));
    dispatch(updateSlug(""));
    dispatch(updateShortDescription(""));
    dispatch(updateContent(""));
    dispatch(updateThumbnailImage(""));
    dispatch(updateFeaturedImage(""));
    dispatch(updateAdditionalImages([]));
  };

  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-lg-6">
          <h1 className="fw-bold" style={{ color: "#1e3a8a" }}>{title}</h1>
          <p className="text-muted">{shortDescription}</p>
          <div className="d-flex align-items-center gap-2 mt-2">
            <span className="badge bg-secondary">DRAFT</span>
          </div>
        </div>
        <div className="col-lg-6">
          {thumbnailImage && (
            <img src={thumbnailImage} alt="Thumbnail" style={{ width: "100%", borderRadius: "12px" }} />
          )}
        </div>
      </div>

      {additionalImages?.length > 0 && (
        <div className="row mt-4">
          {additionalImages.map((img, index) => (
            <div className="col-md-3 mb-3" key={index}>
              <img src={img} alt={`Additional ${index + 1}`} style={{ width: "100%", height: "140px", objectFit: "cover", borderRadius: "8px" }} />
            </div>
          ))}
        </div>
      )}

      <div className="row mt-4">
        <div className="col-lg-8" dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>

      {publishError && <div className="text-danger mt-3">{publishError}</div>}
      {successMsg && <div className="alert alert-success mt-3">News post created successfully (saved as Draft)!</div>}

      {!successMsg ? (
        <div className="text-center mt-5 mb-3">
          <button onClick={handleSubmit} className="btn btn-primary fw-semibold"
            style={{ background: "linear-gradient(90deg, #1e3a8a, #2563eb)", border: "none", padding: "12px 32px", borderRadius: "8px" }}>
            Save as Draft
          </button>
        </div>
      ) : (
        <div className="mt-4 mb-5 text-center">
          <Link to="/news" onClick={handleEmptyField} className="btn btn-outline-primary fw-semibold" style={{ padding: "12px 32px", borderRadius: "8px" }}>
            Browse News & Events
          </Link>
        </div>
      )}
    </div>
  );
}

export default PreviewNews;
